<div class="emma-multitypeinput">
    <div
        *ngFor="let item of value; index as index"
        [@fadeScaleInOut]
        [ngClass]="{
            'form-group m-form__group m-form__group--md row': true,
            'invert-input-order': invertInputOrder
        }"
    >
        <div
            *ngIf="!onlyValues"
            [ngClass]="{
                'col-md-4': !invertInputOrder,
                'col-md-8': invertInputOrder
            }"
        >
            <label *ngIf="typeLabel && (!onlyFirstLabel || !index)">
                {{ typeLabel }}
                <span *ngIf="!allowEmptyType" class="required-label" i18n>Obligatorio</span>
            </label>
            <div [ngClass]="{ 'input-group': allowRemove && invertInputOrder && !readonly }">
                <emma-select
                    *ngIf="itemTypes.length && !typesAsSuggestions && !readonlyKeys"
                    name="multitypeinput.select.first.{{ index }}"
                    [items]="cachedTypeOptions[index]"
                    [(ngModel)]="item[typeKey]"
                    (ngModelChange)="updateItem()"
                    [searchable]="true"
                    [disabled]="disabled"
                    [readonly]="readonlyKeys || readonly"
                    [tabindex]="index + (invertInputOrder ? 2 : 1)"
                    [required]="!allowEmptyType"
                    ($blur)="onBlur()"
                ></emma-select>
                <emma-input
                    *ngIf="!itemTypes.length || (typesAsSuggestions && !readonlyKeys)"
                    name="multitypeinput.input.first.{{ index }}"
                    [type]="typeInputType"
                    [placeholder]="typePlaceholder || typeLabel || ''"
                    [(ngModel)]="item[typeKey]"
                    (ngModelChange)="updateItem()"
                    [disabled]="disabled"
                    [readonly]="readonlyKeys || readonly"
                    [tabindex]="index + (invertInputOrder ? 2 : 1)"
                    [values]="cachedTypeOptions[index] || []"
                    [showSuggestions]="typesAsSuggestions"
                    [showSuggestionsOnEmpty]="true"
                    [allowSuggestionsOnly]="allowTypeSuggestionsOnly"
                    [showHelpMessageAtError]="typeShowHelpMessageAtError"
                    [helpMessageAtError]="typeHelpMessageAtError"
                    [required]="!allowEmptyType"
                    dropdownPosition="bottom"
                    ($blur)="onBlur()"
                ></emma-input>
                <emma-input
                    *ngIf="itemTypes.length && readonlyKeys"
                    [value]="cachedLabels[index]"
                    [disabled]="disabled"
                    [readonly]="readonlyKeys || readonly"
                    [tabindex]="index + (invertInputOrder ? 2 : 1)"
                    ($blur)="onBlur()"
                ></emma-input>
                <ng-container *ngIf="allowRemove && invertInputOrder && !readonly && (!required || index)">
                    <button
                        (blur)="onBlur()"
                        (click)="onRemove(index)"
                        class="btn btn-metal m-btn--icon"
                        type="button"
                        [disabled]="disabled"
                    >
                        <span class="m--font-danger">
                            <i class="la la-trash" aria-hidden="true"></i>
                            <span i18n>Eliminar</span>
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>
        <div
            [ngClass]="{
                'col-md-12': onlyValues,
                'col-md-8': !onlyValues && !invertInputOrder,
                'col-md-4': !onlyValues && invertInputOrder
            }"
        >
            <label *ngIf="valueLabel && (!onlyFirstLabel || !index)">
                {{ valueLabel }}
                <span *ngIf="!allowEmptyValue" class="required-label" i18n>Obligatorio</span>
            </label>
            <div [ngClass]="{ 'input-group': allowRemove && !invertInputOrder && !readonly }">
                <emma-select
                    *ngIf="
                        itemValues.length &&
                        !valuesAsSuggestions &&
                        (!item[valueKey] || itemValues.includes(item[valueKey]))
                    "
                    name="multitypeinput.select.second.{{ index }}"
                    class="form-control m-select m-select--solid"
                    [items]="suggestUsedValues ? itemValues : cachedValues[index]"
                    [(ngModel)]="item[valueKey]"
                    (ngModelChange)="updateItem()"
                    [disabled]="disabled"
                    [readonly]="readonly"
                    [tabindex]="index + (invertInputOrder ? 1 : 2)"
                    [allowAdd]="!allowValueSuggestionsOnly"
                    [searchable]="true"
                    [required]="!allowEmptyValue"
                    ($blur)="onBlur()"
                ></emma-select>
                <emma-input
                    *ngIf="
                        !itemValues.length ||
                        valuesAsSuggestions ||
                        (item[valueKey] && !itemValues.includes(item[valueKey]))
                    "
                    [placeholder]="
                        (valuePlaceholders && valuePlaceholders[item[typeKey]]) ||
                        valuePlaceholder ||
                        valueLabel ||
                        ''
                    "
                    name="multitypeinput.input.second.{{ index }}"
                    [type]="valueInputType"
                    [(ngModel)]="item[valueKey]"
                    (ngModelChange)="updateItem()"
                    [disabled]="disabled"
                    [readonly]="readonly"
                    [values]="(suggestUsedValues ? itemValues : cachedValues[index]) || []"
                    [tabindex]="index + (invertInputOrder ? 1 : 2)"
                    [showSuggestions]="valuesAsSuggestions"
                    [showSuggestionsOnEmpty]="true"
                    [allowSuggestionsOnly]="allowValueSuggestionsOnly"
                    [showHelpMessageAtError]="valueShowHelpMessageAtError"
                    [helpMessageAtError]="valueHelpMessageAtError"
                    [validateFn]="validateValuesFn"
                    [required]="!allowEmptyValue"
                    ($blur)="onBlur()"
                ></emma-input>
                <ng-container *ngIf="allowRemove && !invertInputOrder && !readonly && (!required || index)">
                    <button
                        (blur)="onBlur()"
                        (click)="onRemove(index)"
                        class="btn btn-metal m-btn--icon"
                        type="button"
                        [disabled]="disabled"
                    >
                        <span class="m--font-danger">
                            <i class="la la-trash" aria-hidden="true"></i>
                            <span i18n>Eliminar</span>
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div
        *ngIf="value.length > 0 && createButton && !readonly"
        [@fadeScaleInOut]
        class="m--margin-top-15 m--margin-bottom-15 m-form__separator"
    ></div>
    <div class="form-group m-form__group m-form__group--md m-form__group--last">
        <button
            *ngIf="createButton && !readonly"
            [disabled]="!showCreateButton() || disabled || value.length >= maxlength"
            emmaButton
            color="metal"
            [isWide]="false"
            [hasIcon]="true"
            (click)="onAdd()"
            (blur)="onBlur()"
        >
            <span>
                <i class="la la-plus-circle" aria-hidden="true"></i>
                <span>{{ createButton }}</span>
            </span>
        </button>
    </div>
</div>
